<template>
  <span
    class="
      tw-inline-flex
      tw-items-center
      tw-gap-1.5
      tw-px-3
      tw-py-1
      tw-rounded-full
      tw-border
      tw-bg-sf-snow-dark
      tw-text-xs
    "
    :class="textColorClass"
  >
    <a
      ref="textRef"
      v-tooltip="isTruncated ? title : undefined"
      :href="href"
      :target="openInNewTab ? '_blank' : undefined"
      :rel="openInNewTab ? 'noopener noreferrer' : undefined"
      class="tw-truncate tw-no-underline tw-text-current"
      :style="{ maxWidth: maxWidthPx }"
    >
      {{ title }}
    </a>
    <slot name="suffix" />
  </span>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'

const MAX_WIDTHS = {
  medium: '180px',
  large: '250px',
} as const

type MaxWidthSize = keyof typeof MAX_WIDTHS

interface Props {
  title: string
  href: string
  maxWidth?: MaxWidthSize
  variant?: 'default' | 'primary'
  openInNewTab?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  maxWidth: 'large',
  variant: 'default',
  openInNewTab: false,
})

const maxWidthPx = MAX_WIDTHS[props.maxWidth]

const textRef = ref<HTMLElement>()
const isTruncated = ref(false)

onMounted(() => {
  if (textRef.value) {
    isTruncated.value = textRef.value.scrollWidth > textRef.value.clientWidth
  }
})

const textColorClass = computed(() =>
  props.variant === 'primary'
    ? 'tw-text-sf-primary-dark'
    : 'tw-text-sf-neutral-darker-1'
)
</script>
